import { css } from '@emotion/react'

import { NewsTopics, NewsVersion } from '../hooks/useNewsItems'
import { NewsListItemLink } from './NewsListItemLink'

type NewsTopicsLinkListProps = {
  topics: NewsTopics
  version: NewsVersion
  onLinkClick?: () => void
}

export function NewsTopicsLinkList({ topics, version, onLinkClick }: Readonly<NewsTopicsLinkListProps>) {
  return (
    <div css={styles.topicsContainer}>
      {topics.map((topic) => (
        <NewsListItemLink
          key={`balanced-topic-${topic.id}`}
          to={`/novidades/${version}#${topic.id}`}
          onClick={onLinkClick}
        >
          {topic.title}
        </NewsListItemLink>
      ))}
    </div>
  )
}

const styles = {
  topicsContainer: css`
    &:has(li:nth-child(4)) {
      column-count: 2;
      column-gap: 2rem;
    }
    margin: 0 2rem;
  `,
}
